export default __webpack_public_path__ + "static/media/clean-code.3ce1a3bc.jpg";